import styled from 'styled-components';

const ContactSection = styled.section`
  padding: 80px 50px;
  background-color: white;
  width: 100%;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const Title = styled.h2`
  text-align: center;
  color: #1d3557;
  margin-bottom: 40px;
  font-size: 2.5rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const ContactForm = styled.form`
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #1d3557;
  font-size: 1rem;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 2px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #1d3557;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 2px solid #ddd;
  border-radius: 4px;
  min-height: 150px;
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #1d3557;
  }
`;

const Button = styled.button`
  background-color: #e63946;
  color: white;
  padding: 14px 30px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  width: 100%;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #dc2f3d;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(230, 57, 70, 0.3);
  }
`;

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
  };

  return (
    <ContactSection id="contact">
      <Title>Contactez-nous</Title>
      <ContactForm onSubmit={handleSubmit}>
        <FormGroup>
          <Label>Nom</Label>
          <Input type="text" required />
        </FormGroup>
        <FormGroup>
          <Label>Email</Label>
          <Input type="email" required />
        </FormGroup>
        <FormGroup>
          <Label>Message</Label>
          <TextArea required />
        </FormGroup>
        <Button type="submit">Envoyer</Button>
      </ContactForm>
    </ContactSection>
  );
};

export default Contact;